export default __webpack_public_path__ + "static/media/chartres5.15cd8333.jpg";